/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'vrf-context';
const componentName = 'vrf-context-modal-preview';
const prefix = `${moduleName}.${componentName}`;

export const managementVrfContextLabel = `${prefix}.managementVrfContextLabel`;
export const mangementVrfContextInfo = `${prefix}.managementVrfContextInfo`;
export const segNetworkOverrideInfo = `${prefix}.segNetworkOverrideInfo`;
export const noteLabel = `${prefix}.noteLabel`;
export const defaultGatewayNote = `${prefix}.defaultGatewayNote`;

export const ENGLISH = {
    [managementVrfContextLabel]: 'Management VRF Context',
    [mangementVrfContextInfo]: 'The management VRF Context allows configuration of a static default gateway for Service Engine to Controller management plane communication. A static default gateway is required when DHCP is not used and the Service Engines and Controllers are not within the same IP subnet.',
    [segNetworkOverrideInfo]: 'Where the Service Engine Group management network override feature is used, a distinct static default gateway can be added for each overridden management network that requires it.',
    [noteLabel]: 'Note',
    [defaultGatewayNote]: 'Modifying an existing default gateway\'s next-hop address will not affect the configuration of Service Engines that have already been deployed.',
};
